import React, { createContext, useContext, useState, useCallback } from 'react';
import ContactFormModal from '../components/ContactFormModal';

const ContactFormContext = createContext(null);

export function ContactFormProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [defaultSubject, setDefaultSubject] = useState('');

  const openContactForm = useCallback((options = {}) => {
    setDefaultSubject(options.subject || '');
    setOpen(true);
  }, []);

  const closeContactForm = useCallback(() => {
    setOpen(false);
    setDefaultSubject('');
  }, []);

  return (
    <ContactFormContext.Provider value={{ openContactForm, closeContactForm }}>
      {children}
      <ContactFormModal
        open={open}
        onClose={closeContactForm}
        defaultSubject={defaultSubject}
      />
    </ContactFormContext.Provider>
  );
}

export function useContactForm() {
  const ctx = useContext(ContactFormContext);
  if (!ctx) {
    throw new Error('useContactForm must be used within ContactFormProvider');
  }
  return ctx;
}
